import React, { useRef } from 'react';
import Header from '../components/Header';
import Fecho from '../components/home/Fecho';
import useRevelar from '../components/home/useRevelar';
import Chamada from '../components/blog/Chamada';
import FiguraDoPost from '../components/blog/FiguraDoPost';
import LinhaDoPost from '../components/blog/LinhaDoPost';
import { POSTS, CATEGORIAS, noIdioma, tituloCurto } from '../config/posts';
import { Link, useIdioma } from '../i18n';
import { useFormato } from '../i18n/formato';
import '../styles/NewHome.css';
import '../styles/Notas.css';
import '../styles/NewBlog.css';

/**
 * Lista do blog, no desenho da página inicial nova. Convive com `pages/Blog.js`
 * sem tocar nele: qual das duas atende `/blog` é o import em `App.js`.
 *
 * Busca e filtro por categoria ficaram de fora enquanto há poucos posts: com
 * um só, eram controles sobre uma lista que não muda. Voltam quando a lista
 * passar de meia dúzia.
 */

const DATA_LONGA = { day: 'numeric', month: 'long', year: 'numeric' };
const ORDENADOS = [...POSTS].sort((a, b) => new Date(b.data) - new Date(a.data));

const NewBlog = () => {
  const { t, idioma } = useIdioma();
  const { data } = useFormato();
  const raiz = useRef(null);
  useRevelar(raiz);

  const [destaque, ...anteriores] = ORDENADOS;
  const figura = destaque?.capa?.figura;

  return (
    <>
      <Header />

      <main className="nh notas" ref={raiz}>
        <section className="nh-grade notas-abre" aria-labelledby="notas-titulo">
          <h1 id="notas-titulo">{t('notas.titulo')}</h1>
          <p>{t('notas.chamada')}</p>
        </section>

        {!destaque && (
          <div className="nh-grade">
            <p className="notas-vazio">{t('notas.semPosts')}</p>
          </div>
        )}

        {destaque && (
          <article className="nh-grade notas-destaque" aria-labelledby="destaque-titulo">
            <div className={figura ? 'notas-destaque-texto' : 'notas-destaque-texto is-largo'}>
              <h2 id="destaque-titulo">
                <Link to={`/blog/${destaque.slug}`}>{tituloCurto(destaque, idioma)}</Link>
              </h2>
              <p>{noIdioma(destaque.resumo, idioma)}</p>
              <p className="notas-meta">
                <time dateTime={destaque.data}>{data(destaque.data, DATA_LONGA)}</time> ·{' '}
                {t(CATEGORIAS[destaque.categoria].chave)} · {t('notas.minutos', { n: destaque.leitura })}
              </p>
              <Link to={`/blog/${destaque.slug}`} className="sp-btn sp-btn-on-section nh-btn notas-ler">
                {t('notas.lerPost')} <span className="nh-seta" aria-hidden="true">→</span>
              </Link>
            </div>
            <FiguraDoPost figura={figura} />
          </article>
        )}

        {anteriores.length > 0 && (
          <section className="nh-grade notas-lista" aria-labelledby="anteriores-titulo">
            <h2 id="anteriores-titulo">{t('notas.anteriores')}</h2>
            <ol className="notas-linhas">
              {anteriores.map((p) => <LinhaDoPost post={p} key={p.slug} />)}
            </ol>
          </section>
        )}

        <Chamada titulo={t('notas.fimBlog')} centrada />
      </main>

      <Fecho />
    </>
  );
};

export default NewBlog;
